import headerComponent from './partials/pack-config-header.hbs';
import footerComponent from './partials/pack-config-footer.hbs';
import mainImageComponent from './partials/pack-config-image.hbs';
import reviewComponent from './partials/pack-config-review.hbs';
import packSummaryReview from './partials/pack-config-packsummary-review.hbs';
import packSummaryEdit from './partials/pack-config-packsummary-edit.hbs';
import buildMyOwnConfirmationModalComponent from './partials/pack-config-buildmyown-modal.hbs';
import buildMyOwnStartOverModalComponent from './partials/pack-config-startover-modal.hbs';
import CardLayout from './partials/pack-config-tile.hbs';
import ProductTileHeader from './partials/pack-config-tile-header.hbs';
import ProductScreen from './partials/pack-config-product-screen.hbs';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { initMeter, updateMeter } from './js/meter.js';
import {
    processDefaultPack,
    getProductInPackGroup,
    getSingleProductsInPackGroups,
    firstAvailableProductInGroup,
    firstAvailableFlavorInGroup
} from './js/getDefaultPacks.js';
import {
    generateSelectedProductsFromDefaultPack,
    generateSelectedProductsFromUpdatedDefaultPack,
    updatePackSummaryOnChange
} from './js/getDefaultPackSelectedProducts';
import { togglePackSummaryAccordion } from './js/packSummaryAccordion.js';
import {
    markSelectedProduct,
    emptyProductsIfNotIncludedTypeGroup
} from './js/markSelectedProduct.js';
import { initTooltip, updateTooltip } from './js/tooltip.js';
import * as cartService from '/source/js/services/cartService';
import { announceAddedToCart } from '/source/js/utils/announceUtil';
import { IS_ACTIVE, IS_HIDDEN } from '/source/js/base/baseClasses';
import {
    setDataForAllProducts,
    addGtmTagToCart, addGlobalQueryIdToRequest
} from '/source/js/gtm/IsaGtmCommerce';
import * as inventoryService from '/source/js/services/inventoryService';
import * as productService from '/source/js/services/productService';
import crossSellCards from '/source/_patterns/01-components/product/partials/crossSellCards.hbs';
import {
    getFractionCurrencyFormatter,
    getCurrencyFormatter
} from '/source/js/utils/marketUtil';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';
import {
    ADD_TO_CART_LOADING_STARTED_MESSAGE,
    ADD_TO_CART_LOADING_COMPLETED_MESSAGE,
    ADD_TO_CART_LOADING_ERROR_MESSAGE,
    UPDATE_TO_CART_LOADING_STARTED_MESSAGE,
    UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE,
    UPDATE_TO_CART_LOADING_ERROR_MESSAGE
} from '../common/common';
// Global variables for elements
const PRODUCT_TILES_WRAPPER = '.product-tiles-wrapper';
const tryonceCheckbox = '#tryonce-desktop, #tryonce-mobile';
const BPC = 'Brand-Partner-Customer';
const BPC_SPACED = 'Brand Partner Customer';
const BPCRETAIL = `${BPC}-Retail-Checkout`;
const BPCRETAIL_SPACED = `${BPC_SPACED} Retail-Checkout`;
const PACK_PRICE = '.pack-price';
const PRODUCT = '.product';

let familyId;
let $header;
let $footer;
let $content;
let $reviewPackSummaryContainer;
let $buildMyOwnBtn;
let $buildMyOwnConfirmationModal;
let $buildMyOwnModalCloseBtn;
let $buildMyOwnModalHeader;
let $buildMyOwnHeaderText;
let $reviewProductEditBtn;
let $buildMyOwnContinueBtn;
let $prevBtn;
let $nextBtn;
let $addCartBtn;
let crossSellData;
let fractionCurrencyFormatter;
let currencyFormatter;
let marketSettings = window.algoliaData?.currentMarketSettingsContext || {
    LocaleName: 'en-US',
    Currency: 'USD',
    MinimumFractionDigits: 2,
    MaximumFractionDigits: 2,
    CurrencySymbolAbbreviation: '',
    MaximumDecimalsForWholeNumber: 0
};
let calculatedPackagePrice = 0;
let packBaseBV = 0;
let isFirstLoad = true;
let QUERY_ID;
let INDEX_NAME;

// Variables for data related
let selectedProducts = {}; // Use this for add to cart functionality later
let extensiveProductData;
let productData;
let sortedDefaultPackData;
let footerData;
let defaultPack;
let packGroups;
let defaultTotalPackPrice;
let updatedTotalPackPrice;

let currentPage = 1;
let maxPage;
let outOfStockProductIds = [];
let isBuildForMeFlow;

// pack config integration
let shouldTogglePackBuilderData = false;
let selectedPriceType;
let selectedPack;
let inventoryResponse;
let packConfigBuilder;
const isMobile = () => window.innerWidth <= 1160;

const isTablet = () => window.innerWidth >= 576 && window.innerWidth < 767;

const initBuildMyOwnConfirmationModal = () => {
    $('.modal-backdrop').addClass('build-my-own');
    $buildMyOwnConfirmationModal.modal('show');
};

const isManageAutoship = () => extensiveProductData.ProductDetailsViewModalModel.IsManageAutoship;

const closeBuildMyOwnModal = () => {
    $('.modal-backdrop').removeClass('build-my-own');
    $buildMyOwnConfirmationModal.modal('toggle');
};

const updatePageIndicator = (number, totalPage, groupid) => {
    const $indicator = $(
        `.product-tiles__indicator[data-groupid='${groupid}'] span`
    );
    var $indicatorText = extensiveProductData.Labels.Steps.replace('[0]', number).replace('[1]', totalPage);
    $indicator.text($indicatorText);
};

const getGroupTotal = ($group) => {
    let total = 0;
    $group.find('.stepgroup-qty').each(function (index, item) {
        total += parseInt($(item).val());
    });
    return total;
};

const toggleFlavourSelection = ($flavorContainer, method) => {
    if(!$flavorContainer) {
        return;
    }
    const flavourImage = $flavorContainer.find('.img-fluid');
    const checkMark = $flavorContainer.find('.check-mark-container');
    const checkMarkImage = $flavorContainer.find('.check-mark-container .check-mark');
    if(method === 'show') {
        flavourImage.addClass('selected');
        checkMark.show();
        checkMarkImage.show();
    } else {
        flavourImage.removeClass('selected');
        checkMark.hide();
        checkMarkImage.hide();
    }
};

const toggleRestrictQuantitySelectors = (groupId = undefined, method) => {
    $(`.product-tiles[data-groupid='${groupId}']`)
        .find('.product-tiles__card')
        .each(function (e) {
            $(this)
                .find('.product-tiles__flavors__option-card-footer')
                .each(function (e) {
                    const flavorInput = $(this).find('input');
                    if(+flavorInput.val() === 0) {
                        if(method) {
                            $(this).addClass('is--disabled');
                        } else {
                            $(this).removeClass('is--disabled');
                        }
                    } else if(flavorInput.val() >= 0) {
                        $(this).removeClass('is--disabled');
                    }
                });
        });
};

const clearAllClickHandler = (e) => {
    const $this = $(e.currentTarget);
    const groupId = $this.data('groupid');
    const activeCard = 'active-card';

    // We are clicking the minus button for a prticular group and product with their quantity till it becomes zero
    for (let [productId, quantiy] of Object.entries(selectedProducts[groupId])) {
        const $productInput = $(`#group${groupId}-product${productId}`);
        for (let i = 0; i <= quantiy; i++) {
            $productInput.siblings('.qty-addsub-minus-btn').click();
        }
    }
    $(`.product-tiles[data-groupid=${groupId}]`)
        .find('.product-tiles__card')
        .each(function (e) {
            $(this).removeClass(activeCard);
        });
};

const isAddToCartbtnAvailable = () => {
    const datas = [];
    $('.product-tiles').each(function (e) {
        datas.push($(this).attr('data-completed'));
    });

    return datas.every((data) => data === 'true');
};

function handleFooterButtons(groupid, currentPageN) {
    $prevBtn = $('.cart-btn-prev');
    $nextBtn = $('.cart-btn-next');

    const isCartAvailable = isAddToCartbtnAvailable();
    const packgroupIsCompleted = $(
        `.product-tiles[data-groupid=${groupid}]`
    ).attr('data-completed');
    const packGroupIdx =
        extensiveProductData.BundleConfiguration.PackGroups.findIndex(
            (e) => e.GroupID === groupid
        );

    const isPreviousPageCompleted = $(`.product-tiles[data-groupid=${groupid}]`)
        .prev()
        .attr('data-completed');
    const isNextPageCompleted = $(`.product-tiles[data-groupid=${groupid}]`)
        .next()
        .attr('data-completed');
    const isNextPageExist = Boolean(isNextPageCompleted);
    const isPreviousPageExist = Boolean(isPreviousPageCompleted);
    const currentPage = packGroupIdx + 1;

    if(isPreviousPageExist) {
        if(!$('.js-summary-dropdown').hasClass('open') && !isBuildForMeFlow) {
            $prevBtn.show();
        }
        $prevBtn.prop('disabled', false);
    } else {
        $prevBtn.hide();
    }
    if(isNextPageExist) {
        if(!$('.js-summary-dropdown').hasClass('open') && !isBuildForMeFlow) {
            $nextBtn.show();
            $('.review-my-pack-btn').addClass('d-none');
        }
        // we always set Next button as enabled, regardless of group
        // being completely selected or not
        $nextBtn.prop('disabled', false);
        if($addCartBtn) {
            if(isBuildForMeFlow && !isMobile()) {
                $addCartBtn.show();
                $addCartBtn.prop('disabled', true);
            } else {
                $addCartBtn.hide();
            }
        }
    } else {
        if(isMobile() && !isBuildForMeFlow && !$('.js-summary-dropdown').hasClass('open')) {
            $addCartBtn.hide();
            $('.review-my-pack-btn').removeClass('d-none');
        } else if(!isMobile()) {
            $addCartBtn.show();
            $('.review-my-pack-btn').addClass('d-none');
        } else if(isTablet() && $('.js-summary-dropdown').hasClass('open')) {
            $('.review-my-pack-btn').addClass('d-none');
            $addCartBtn.show();
        } else if($('.js-summary-dropdown').hasClass('open')) {
            $('.review-my-pack-btn').addClass('d-none');
        }

        $nextBtn.hide();
        if(isMobile() && !isBuildForMeFlow && !$('.js-summary-dropdown').hasClass('open') && currentPageN !== maxPage) {
            $('.review-my-pack-btn').addClass('d-none');
            $nextBtn.show();
        }
    }

    if(packgroupIsCompleted === 'true') {
        $nextBtn.prop('disabled', false);
    }

    if(isCartAvailable) {
        $addCartBtn.prop('disabled', false);
        if(!isBuildForMeFlow) $('.start-over-btn').show();
    } else if(currentPage !== maxPage && packgroupIsCompleted !== 'true') {
        $('.start-over-btn').hide();
        if(isBuildForMeFlow && !isMobile()) {
            $addCartBtn.show();
        } else {
            $addCartBtn.hide();
        }
    } else {
        $('.start-over-btn').hide();
        $addCartBtn.prop('disabled', true);
    }
}

const scrollToSelectedPackSummaryItem = () => {
    const selectedPackSummaryItem = $(
        '.pack-summary__item[data-is-selected="true"]'
    );

    if(selectedPackSummaryItem.length) {
        const offsetTop = selectedPackSummaryItem.position().top;
        const currentScrollTop = $('.pack-summary').scrollTop();
        const newScrollTop =
            currentScrollTop + offsetTop - $('.pack-summary').height() / 10;
        $('.pack-summary').animate({ scrollTop: newScrollTop }, 500);
        focusFirstFocusableElement(selectedPackSummaryItem);
    }
};

function focusFirstFocusableElement($element) {
    if($element.length) {
        $element.focus();
    }
}

const editGroupBtnHandler = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    let targetGroupID = $this.data('groupid');
    let packSummaryContainer = $('.pack-summary');
    let productTilesWrapper = $('.product-tiles-wrapper');
    let dropdown = $('.js-summary-dropdown');

    packSummaryContainer.children().each(function () {
        let editBtn = $(this).find('.edit-product-btn');
        let parentEl = editBtn.closest('.pack-summary__item');

        if(editBtn.data('groupid') === targetGroupID) {
            editBtn.prop('disabled', true);
            parentEl.attr('data-is-selected', true);
            parentEl.addClass('editing-card');
        } else {
            editBtn.prop('disabled', false);
            parentEl.attr('data-is-selected', false);
            parentEl.removeClass('editing-card');
        }
    });

    if($('.product-tiles-wrapper').length > 0) {
        $('.product-tiles-wrapper')
            .children()
            .each(function () {
                if($(this).data('groupid') === targetGroupID) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
    }

    if(isMobile()) {
        let isDropdownOpen = $(dropdown).hasClass('open');
        if(isDropdownOpen) {
            $(dropdown).removeClass('open');
            packSummaryContainer.hide();
            productTilesWrapper.show();
        } else {
            $(dropdown).addClass('open');
            packSummaryContainer.show();
            productTilesWrapper.hide();
        }
    }
};

const checkAndUpdateButtonStatus = (groupID) => {
    const selectedGroup = selectedProducts[groupID];
    const isEmptyObject = $.isEmptyObject(selectedGroup);
    const clearAllButton = $(`.js-clear-items[data-groupid="${groupID}"]`);

    if(isEmptyObject) {
        clearAllButton.prop('disabled', true);
    } else {
        clearAllButton.prop('disabled', false);
    }
};

const updateSelectedProductCardStatus = ($productGroup, $clickedCard) => {
    const active = 'active-card';

    $($productGroup)
        .find('.product-tiles__card')
        .each(function (e) {
            if($(this).data('name') === $($clickedCard).data('name')) {
                $(this).addClass(active);
            } else {
                $(this).removeClass(active);
            }
        });
};

const calculateTotalPackPrice = (upchargeAmount, selector) => {
    const $displayPriceEl = $('.packconfig-display-price');

    if(upchargeAmount === 0) {
        return false;
    }

    if(selector === 'plus') {
        updatedTotalPackPrice += upchargeAmount;
    }
    if(selector === 'minus') {
        updatedTotalPackPrice -= upchargeAmount;
    }

    const formattedTotalPackPrice = updatedTotalPackPrice
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const totalPackPriceText = formattedTotalPackPrice.replace(/\.00$/, '');
    $displayPriceEl.text(`$${totalPackPriceText}`);
};

const handleQuantity = (e) => {
    e.preventDefault();
    let $clickedBtn = $(e.currentTarget);
    let $cartBtnContinue = $('.cart-btn-continue');
    let $productGroup = $clickedBtn.closest('.product-tiles');
    let $input = $('input[name="' + $clickedBtn.data('field') + '"]');
    let $flavorCard = $clickedBtn.closest('.product-tiles__flavour-card');
    let $clickedCard = $clickedBtn.closest('.product-tiles__card');
    let groupID = $productGroup.attr('id');
    const groupIDnumber = groupID.split('_').at(1);
    let groupMax = parseInt($productGroup.data('max'));
    let total = getGroupTotal($productGroup);
    let value = parseInt($input.val());
    let valueMin = 0;
    let upchargeAmount = $input.data('upcharge-amount');

    // Check if a number is in the field first
    if(isNaN(value) || value < valueMin) {
        // If field value is NOT a number, or
        // if field value is less than minimum,
        // ...set value to 0 and exit function
        $input.val(valueMin);
        return false;
    } else if(value > groupMax) {
        // If field value exceeds maximum,
        // ...set value to max
        $input.val(groupMax);
        return false;
    }
    // Perform increment or decrement logic
    if($clickedBtn.data('func') === 'plus') {
        if(total < groupMax) {
            $input.val(value + 1);
            total++;
            toggleFlavourSelection($flavorCard, 'show');
            calculateTotalPackPrice(upchargeAmount, 'plus');
        }
        $flavorCard.find('.qty-addsub-minus-btn').prop('disabled', false);

        if(value > groupMax) {
            $flavorCard.find('.qty-addsub-plus-btn').prop('disabled', true);
        }
    } else {
        if(value > valueMin) {
            $input.val(value - 1);
            total--;
            $productGroup.attr('data-completed', 'false');
            calculateTotalPackPrice(upchargeAmount, 'minus');
        }

        if(value <= 1) {
            value = 1;
            $flavorCard.find('.qty-addsub-minus-btn').prop('disabled', true);
            toggleFlavourSelection($flavorCard, 'hide');
        } else {
            $flavorCard.find('.qty-addsub-plus-btn').prop('disabled', false);
        }
    }

    // update selected product list
    let groupId = $input.data('groupid');
    let prodId = $input.data('productid');
    if(!!groupId && !!prodId) {
        let groupElement = {};

        if(Object.prototype.hasOwnProperty.call(selectedProducts, groupId)) {
            groupElement = selectedProducts[groupId];
        }
        let quantityValue = parseInt($input.val());
        if(typeof quantityValue === 'number' && quantityValue > 0) {
            groupElement[prodId] = quantityValue;
            selectedProducts[groupId] = groupElement;
        } else {
            delete groupElement[prodId];
        }
    }

    // Checks if total items are added
    // If not max items, hide checkmark and selected group class
    if(total < groupMax) {
        $productGroup.attr('data-completed', 'false');
        $productGroup.removeClass('complete');
    } else {
        $productGroup.attr('data-completed', 'true');
        $productGroup.addClass('complete');
    }

    if(total !== groupMax) {
        $cartBtnContinue.show();
        toggleRestrictQuantitySelectors(groupIDnumber, false);
    } else {
        $cartBtnContinue.hide();
        toggleRestrictQuantitySelectors(groupIDnumber, true);
    }

    updateSelectedProductCardStatus($productGroup, $clickedCard);

    checkAndUpdateButtonStatus(groupIDnumber);
    if(!isBuildForMeFlow) {
        handleFooterButtons(groupIDnumber, currentPage);
    } else {
        handleAddToCartOnBuildForMe();
    }

    updateTooltip(groupMax, groupIDnumber, extensiveProductData.Labels);

    updateMeter(total, groupMax, groupIDnumber);
    updatePackSummaryOnChange(selectedProducts, packGroups, groupIDnumber);
    updatePackUpcharges(calculateTotalUpcharge());

    console.log(
        'selectedProducts after an quantity update has been made: ',
        selectedProducts
    );
};

const buildForMe = () => {
    let productIDs = [];
    let packToProcess = selectedPack || extensiveProductData.BundleConfiguration.DefaultPack;
    $.each(
        packToProcess,
        function (index) {
            let defaultPack = packToProcess[index];
            let matchingPackGroup = extensiveProductData.BundleConfiguration.PackGroups.find(
                (i) => i.GroupID === defaultPack.GroupID);

            if(!matchingPackGroup || matchingPackGroup.length < 1) return;
            let packGroup = matchingPackGroup;
            let groupID = defaultPack.GroupID;
            let currentID = packGroup.GroupID;
            let currentMax = packGroup.MaxQuantity;
            let max = -1;
            let group = currentID === groupID;
            if(group) {
                max = currentMax;
            }
            const $productGroup = $(`.product-tiles[data-groupid=${groupID}]`);
            $productGroup.attr('data-completed', 'true');
            let count = 0;
            if(defaultPack.Products.length === 0) {
                // get first available product
                let productItem = firstAvailableProductInGroup(packGroup, outOfStockProductIds);
                let defaultQty = parseInt(packGroup.MaxQuantity);
                updateProductItemInGroupCard(groupID, productItem.flavorProduct, defaultQty);
                productIDs.push(productItem.ID);
            } else {
                $.each(defaultPack.Products, function (innerIndex) {
                    if(count >= max) return false;
                    let product = defaultPack.Products[innerIndex];
                    let qty = 0;
                    let { flavorProduct } = getProductInPackGroup(matchingPackGroup, product);

                    if(!flavorProduct || (!isManageAutoship() && (outOfStockProductIds.includes(flavorProduct.ID)))) {
                        $(`#group${groupID}-product${product.ProductID}.new-config-btn`)
                            .parent()
                            .find('.qty-addsub-btn, .stepgroup-qty')
                            .prop('disabled', true);
                        $(`#group${groupID}-product${product.ProductID}.new-config-btn`)
                            .parents('.product-tiles__flavour-card ')
                            .addClass('is--disabled');
                        if(flavorProduct) {
                            let availableProduct = firstAvailableFlavorInGroup(matchingPackGroup, flavorProduct, outOfStockProductIds);
                            qty = parseInt(product.Quantity) || 1;
                            updateProductItemInGroupCard(availableProduct.selectedGroup.GroupID, availableProduct.flavorProduct, qty);
                            productIDs.push(product.ProductID);
                            count += qty;
                        }
                        return true;
                    }
                    qty = parseInt(product.Quantity) || 1;
                    updateProductItemInGroupCard(groupID, flavorProduct, qty);
                    productIDs.push(product.ProductID);
                    count += qty;
                });
            }
        }
    );
};

function updateProductItemInGroupCard(groupID, productItem, qty) {
    let $productInput = $(`#group${groupID}-product${productItem.ID}.new-config-btn`);
    $productInput.siblings('.qty-addsub-minus-btn').prop('disabled', false);
    $productInput.val(qty);
    $productInput.siblings('.qty-addsub-btn.new-config-btn').click();
    toggleRestrictQuantitySelectors(groupID, true);
    updateSelectedProductCardStatus(
        $(`.product-tiles[data-groupid=${groupID}]`),
        $productInput.closest('.product-tiles__card')
    );
    $productInput
        .closest('.product-tiles__flavour-card')
        .find('img.img-fluid')
        .addClass('selected');
    $productInput
        .closest('.product-tiles__flavour-card')
        .find('.check-mark-container, .check-mark')
        .show();
}

function calculatePackPreselectedUpcharges() {
    let packToProcess = selectedPack || extensiveProductData.BundleConfiguration.DefaultPack;
    let totalUpcharge = 0;
    let totalBV = 0;
    $.each(
        packToProcess,
        function (index) {
            let defaultPack = packToProcess[index];
            let matchingPackGroup = extensiveProductData.BundleConfiguration.PackGroups.find(
                (i) => i.GroupID === defaultPack.GroupID);

            if(!matchingPackGroup || matchingPackGroup.length < 1) return;
            let packGroup = matchingPackGroup;
            $.each(defaultPack.Products, function (innerIndex) {
                let product = defaultPack.Products[innerIndex];
                let { flavorProduct } = getProductInPackGroup(packGroup, product);
                let productItem = flavorProduct;
                let qty = parseInt(product.Quantity);
                if(outOfStockProductIds.includes(productItem.ID)) return true;
                if(qty === 0 || productItem.UpchargeDisabled) return true;

                totalUpcharge += (qty * productItem.UpchargeAmount);
                totalBV += (qty * productItem.UpchargeBV);
            });
        }
    );
    return { totalUpcharge, totalBV };
}

function GeneratePage(curPage) {
    const availablePackGroups =
        extensiveProductData.BundleConfiguration.PackGroups;
    const page = availablePackGroups.at(curPage - 1);
    const pageId = page.GroupID;

    $(PRODUCT_TILES_WRAPPER).show();
    $('.product-tiles').each(function (e) {
        if($(this).data('groupid') === pageId) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
    checkAndUpdateButtonStatus(pageId);
    handleFooterButtons(pageId, curPage);
}

function handleAddToCartOnBuildForMe() {
    if(!isMobile() && !$('.js-summary-dropdown').hasClass('open')) {
        $addCartBtn.show();
    }

    if($nextBtn || $prevBtn) {
        $nextBtn.hide();
        $prevBtn.hide();
    }
    const isCartAvailable = isAddToCartbtnAvailable();
    if(isCartAvailable) {
        $addCartBtn.prop('disabled', false);
    } else {
        $addCartBtn.prop('disabled', true);
    }
}

function categoryCardClickHandler(e) {
    const groupId = $(this).data('groupid');
    const clickedPageNum =
        extensiveProductData.BundleConfiguration.PackGroups.findIndex(
            (pack) => pack.GroupID === groupId
        ) + 1;
    if(clickedPageNum === currentPage || clickedPageNum > maxPage) {
        return;
    }
    $('.pack-summary__item').attr('data-is-selected', 'false');
    $('.pack-summary__item').removeClass('editing-card');
    $(this).addClass('editing-card');
    $(this).attr('data-is-selected', 'true');
    currentPage = clickedPageNum;
    if(isMobile()) {
        if($('.js-summary-dropdown').hasClass('open')) {
            $('.js-summary-dropdown').trigger('click');
        }
    }
    GeneratePage(currentPage);
}

function initializeBuildFlow() {
    isBuildForMeFlow = !isBuildForMeFlow;
    $buildMyOwnModalHeader = $('.build-my-own__modal-title');
    $buildMyOwnHeaderText = $('.header-container .header-description-text');
    const $displayPriceEl = $('.packconfig-display-price');

    if(isBuildForMeFlow) {
        // build for me flow
        currentPage = 1;
        selectedProducts = generateSelectedProductsFromDefaultPack(defaultPack);
        closeBuildMyOwnModal();
        $buildMyOwnModalHeader.text(extensiveProductData.Labels.BuildMyOwn);
        $buildMyOwnHeaderText.text(extensiveProductData.Labels.BuildMyOwnTitle);
        $buildMyOwnBtn.text(extensiveProductData.Labels.BuildMyOwn);
        $content.empty();
        initializePage({ isBuildForMeReset: true });
        postPageInitialization();
        handleAddToCartOnBuildForMe();
        console.log('selectedProducts build for me flow: ', selectedProducts);
        const $selector = packConfigBuilder.find('.pack-config-builder__content').first();
        if($selector.length) {
            const $focusableElements = getFocusableElements($selector).not(':disabled');
            if($focusableElements.length) {
                $focusableElements.first().focus();
            }
        }
    } else {
        // build my own flow
        currentPage = 1;
        selectedProducts = {};
        closeBuildMyOwnModal();
        $buildMyOwnModalHeader.text(extensiveProductData.Labels.BuildForMe);
        $buildMyOwnHeaderText.text(extensiveProductData.Labels.BuildForMeTitle);
        $buildMyOwnBtn.text(extensiveProductData.Labels.BuildForMe);
        $content.empty();
        renderProductTilesInPages();
        GeneratePage(currentPage);

        let emptiedDefaultPack = emptyProductsIfNotIncludedTypeGroup(defaultPack);
        let sortedEmptiedDefaultPack = processDefaultPack(
            emptiedDefaultPack,
            packGroups,
            outOfStockProductIds
        );

        let groupID = sortedEmptiedDefaultPack[0].GroupID; // select the first group in the default pack

        let updatedEmptiedDefaultPack = markSelectedProduct(
            sortedEmptiedDefaultPack,
            groupID
        );
        const { Labels } = extensiveProductData;
        let packSummaryEditHtml = packSummaryEdit({
            packData: updatedEmptiedDefaultPack,
            isBuildForMeFlow: false,
            Labels
        });

        $content.append(packSummaryEditHtml);
        productTilesEventHandlerBinding();

        let meterElement = $('.pack-summary__item').find(
            '.meter.meter-pack-summary'
        );
        $(meterElement).each(function (index, item) {
            let maxQty = $(item).data('maxquantity');
            let associatedGroupID = $(item).data('groupid');
            initMeter(0, maxQty, associatedGroupID, true);
        });
        enableDisableProduct(outOfStockProductIds);
        preSelectSingleProductInGroup();
        console.log('selectedProducts build my own flow: ', selectedProducts);
        const $productCard = $(`#productCard_${groupID}`);
        if($productCard.length) {
            $productCard.find('.product-name').focus();
        }
    }

    // reset and update total pack price
    updatedTotalPackPrice = defaultTotalPackPrice;
    let formattedDefaultTotalPackPrice = defaultTotalPackPrice
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    formattedDefaultTotalPackPrice.replace(/\.00$/, '');
    $displayPriceEl.text(`$${formattedDefaultTotalPackPrice}`);
}

function preSelectSingleProductInGroup() {
    const packGroups = extensiveProductData.BundleConfiguration.PackGroups;
    const singleProducts = getSingleProductsInPackGroups(packGroups, outOfStockProductIds);
    if(singleProducts && singleProducts.length > 0) {
        console.log('Single products in groups: ', singleProducts);
        singleProducts.forEach(productData => {
            let $input = $(`input.stepgroup-qty.new-config-btn[data-productid="${productData.ProductId}"]`);
            if($input.length > 0 && productData.MaxQuantity) {
                for (let i = 0; i < productData.MaxQuantity; i++) {
                    $input.siblings('.qty-addsub-plus-btn').trigger('click');
                }
            }
        });
    }
}

function renderProductTilesInPages() {
    $content.append(
        `<div class="product-tiles-wrapper" style="display:none;"></div>`
    );
    let $productTilesWrapper = $(PRODUCT_TILES_WRAPPER);
    maxPage = extensiveProductData.BundleConfiguration.PackGroups.filter(
        (group) => group.GroupType !== 'Included'
    ).length;

    const { Labels } = extensiveProductData;
    extensiveProductData.BundleConfiguration.PackGroups.filter(
        (group) => group.GroupType !== 'Included'
    ).forEach((packgroup, i) => {
        $productTilesWrapper.append(ProductScreen(packgroup));
        const $groupContainer = $(
            `.product-tiles[id='productCard_${packgroup.GroupID}']`
        );
        const $headerContainer = $groupContainer.find(
            '.product-tiles__header-container'
        );

        const headerHtml = ProductTileHeader({ packgroup, Labels });
        $headerContainer.append(headerHtml);
        updatePageIndicator(i + 1, maxPage, packgroup.GroupID);

        const $CardContainer = $groupContainer.find(
            '.product-tiles__card-container'
        );
        let cardHtml = CardLayout(packgroup);
        $CardContainer.append(cardHtml);
        if(isBuildForMeFlow) {
            initMeter(
                packgroup.MaxQuantity,
                packgroup.MaxQuantity,
                packgroup.GroupID
            );
            initTooltip(packgroup.MaxQuantity, packgroup.GroupID, extensiveProductData.Labels);
        } else {
            initMeter(0, packgroup.MaxQuantity, packgroup.GroupID);
            initTooltip(packgroup.MaxQuantity, packgroup.GroupID, extensiveProductData.Labels);
        }
    });
}

function productTilesEventHandlerBinding() {
    $('.qty-addsub-btn.new-config-btn').on('click', handleQuantity);
    $('.js-clear-items').on('click', clearAllClickHandler);
    $('.js-summary-dropdown').on('click', (e) => togglePackSummaryAccordion(e, isBuildForMeFlow));
    $('.edit-product-btn').on('click', (e) => editGroupBtnHandler(e));
    $('.start-over-btn').on('click', startOverInitHandler);
    $('.js-startover-close').on('click', startOverCloseHandler);
    $('.review-my-pack-btn').on('click', function (e) {
        if(!$('.js-summary-dropdown').hasClass('open')) {
            $('.js-summary-dropdown').trigger('click');
            $(this).addClass('d-none');
            $('.cart-add-btn').show();
        }
    });
    $('.build-my-own__continue-startover-btn').on('click', startOverBuildMyOwn);
    $('.pack-summary__item').on(
        'click',
        categoryCardClickHandler
    );
}

async function addCrossSellProductToCart(selectedProduct) {
    if(!selectedProduct) return;

    let quantity = 1;
    showSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);

    let cleanUrl = selectedProduct.Url;
    if(selectedProduct.Url != null && selectedProduct.Url.indexOf('?') > 0) {
        cleanUrl = cleanUrl.substring(0, cleanUrl.indexOf('?'));
    }

    try {
        let result;

        if(selectedProduct.IsKit) {
            result = await cartService.addKitToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                BundleConfigurationId: selectedProduct.BundleConfigurationId,
                Sku: selectedProduct.Sku,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                ProductFamilyDisplayName: selectedProduct.ProductFamilyDisplayName,
                TryOnce: false,
                IsCrossSell: true
            }));
        } else {
            result = await cartService.addToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                TryOnce: false,
                IsCrossSell: true
            }));
        }

        if(result.IsSuccessful) {
            hideSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
            cartService.updateQSForMergeCart();
            if(result.RedirectString) {
                window.location.href = result.RedirectString;
            }
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            updateSubHeader(result);
        } else {
            hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
    }
}

function updateSubHeader(result) {
    let itemCount = result.QuantityTotal || result.TotalItemCount;
    let productName = result.Name || result.ProductName || '';
    $('.header__cart-items').removeClass('d-none').text(itemCount);
    announceAddedToCart(productName, itemCount);
    let $subHeader = $('.isa-modal__cart .card-subheader');
    if(!$subHeader.length) {
        return;
    }
    let subtitle = $subHeader.data('title');
    subtitle = subtitle.replace('###', itemCount);
    $subHeader.empty().append(subtitle);
}

function startOverInitHandler() {
    const $startOverModal = $('#BuildMyOwnStartOverModal');
    $('.modal-backdrop').addClass('build-my-own');
    $startOverModal.modal('show');
}

function startOverCloseHandler() {
    const $startOverModal = $('#BuildMyOwnStartOverModal');
    $('.modal-backdrop').removeClass('build-my-own');
    $startOverModal.modal('hide');
}

function startOverBuildMyOwn() {
    // build my own flow
    const $displayPriceEl = $('.packconfig-display-price');

    currentPage = 1;
    selectedProducts = {};
    $content.empty();
    renderProductTilesInPages();
    GeneratePage(currentPage);
    startOverCloseHandler();

    let emptiedDefaultPack = emptyProductsIfNotIncludedTypeGroup(defaultPack);
    let sortedEmptiedDefaultPack = processDefaultPack(
        emptiedDefaultPack,
        packGroups,
        outOfStockProductIds
    );

    let groupID = sortedEmptiedDefaultPack[0].GroupID; // select the first group in the default pack

    let updatedEmptiedDefaultPack = markSelectedProduct(
        sortedEmptiedDefaultPack,
        groupID
    );
    const { Labels } = extensiveProductData;
    let packSummaryEditHtml = packSummaryEdit({
        packData: updatedEmptiedDefaultPack,
        isBuildForMeFlow: false,
        Labels
    });

    $content.append(packSummaryEditHtml);
    productTilesEventHandlerBinding();

    let meterElement = $('.pack-summary__item').find('.meter.meter-pack-summary');
    $(meterElement).each(function (index, item) {
        let maxQty = $(item).data('maxquantity');
        let associatedGroupID = $(item).data('groupid');
        initMeter(0, maxQty, associatedGroupID, true);
    });

    console.log('selectedProducts build my own flow: ', selectedProducts);

    // reset and update total pack price
    updatedTotalPackPrice = defaultTotalPackPrice;
    let formattedDefaultTotalPackPrice = defaultTotalPackPrice
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    formattedDefaultTotalPackPrice.replace(/\.00$/, '');
    $displayPriceEl.text(`$${formattedDefaultTotalPackPrice}`);
    enableDisableProduct(outOfStockProductIds);
    preSelectSingleProductInGroup();
}

function renderProductPage(e) {
    e.preventDefault();
    showSpinner('Rendering products on page started');
    renderProductTilesInPages();

    if(isBuildForMeFlow) {
        buildForMe();
        if(isMobile()) {
            $('.cart-add-btn').hide();
            $('.review-my-pack-btn').removeClass('d-none');
        }
    } else {
        $('.review-my-pack-btn').addClass('d-none');
    }
    enableDisableProduct(outOfStockProductIds);
    const groupID = $(this).data('groupid');

    const $tilesWrapper = $content.find(PRODUCT_TILES_WRAPPER);
    $content.html($tilesWrapper);

    if(isBuildForMeFlow) {
        // append the pack summary for "build-for-me" flow
        let updatedDefaultPackData = markSelectedProduct(
            sortedDefaultPackData,
            groupID
        );
        const { Labels } = extensiveProductData;
        let packSummaryEditHtml = packSummaryEdit({
            packData: updatedDefaultPackData,
            isBuildForMeFlow: true,
            Labels
        });
        selectedProducts = generateSelectedProductsFromUpdatedDefaultPack(updatedDefaultPackData);
        $content.append(packSummaryEditHtml);
    }

    // TBD: append the pack summary for "build-my-own" flow
    productTilesEventHandlerBinding();

    let meterElement = $('.pack-summary__item').find('.meter.meter-pack-summary');

    // display product tiles
    $(PRODUCT_TILES_WRAPPER).show();
    $('.product-tiles').each(function (e) {
        if($(this).data('groupid') === groupID) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    if(isBuildForMeFlow) {
        $(meterElement).each(function (index, item) {
            let maxQty = $(item).data('maxquantity');
            let associatedGroupID = $(item).data('groupid');
            initMeter(maxQty, maxQty, associatedGroupID, true);
        });
        $('.product-tiles__indicator').hide();
        $('.cart-btn-prev').hide();
        $('.cart-btn-next').hide();
    }

    scrollToSelectedPackSummaryItem();
    hideSpinner('Rendering products on page completed');
}

function nextBtnHandler(e) {
    const selectedPackSummaryItem = $(
        '.pack-summary__item[data-is-selected="true"]'
    );
    const nextPackSummaryItem = selectedPackSummaryItem.next(
        '.pack-summary__item'
    );

    currentPage += 1;
    maxPage = extensiveProductData.BundleConfiguration.PackGroups.filter(
        (group) => group.GroupType !== 'Included'
    ).length;
    $prevBtn.show();
    $('.review-my-pack-btn').addClass('d-none');
    if(currentPage === maxPage) {
        $(this).hide();
        $prevBtn.show();
        $addCartBtn.show();
        $('.review-my-pack-btn').removeClass('d-none');
    }
    GeneratePage(currentPage);

    selectedPackSummaryItem.attr('data-is-selected', false);
    nextPackSummaryItem.attr('data-is-selected', true);
    selectedPackSummaryItem.removeClass('editing-card');
    nextPackSummaryItem.addClass('editing-card');
    scrollToSelectedPackSummaryItem();
}

function prevBtnHandler(e) {
    const selectedPackSummaryItem = $(
        '.pack-summary__item[data-is-selected="true"]'
    );
    const nextPackSummaryItem = selectedPackSummaryItem.prev(
        '.pack-summary__item'
    );

    $nextBtn.show();
    $addCartBtn.hide();
    $('.review-my-pack-btn').addClass('d-none');
    if(currentPage === 1) {
        $(this).hide();
    }
    currentPage -= 1;
    const previousId = extensiveProductData.BundleConfiguration.PackGroups.at(
        currentPage - 1
    ).GroupID;
    const isPreviousStepCompleted = $(
        `.product-tiles[data-groupid=${previousId}]`
    ).attr('data-completed');
    if(isPreviousStepCompleted === 'true') {
        $nextBtn.attr('disabled', false);
    }
    GeneratePage(currentPage);

    selectedPackSummaryItem.attr('data-is-selected', false);
    nextPackSummaryItem.attr('data-is-selected', true);
    selectedPackSummaryItem.removeClass('editing-card');
    nextPackSummaryItem.addClass('editing-card');
    scrollToSelectedPackSummaryItem();
}

const getTryoncePreference = () => {
    const checkboxes = $(tryonceCheckbox);
    if(!checkboxes) {
        return false;
    } else {
        return $(tryonceCheckbox).prop('checked');
    }
};

function crossSellAddPack() {
    let $href = $(this).siblings('.crossSell-anchor').attr('href');
    $href = $href + '&open=1&iscrosssell=1';
    window.location.href = $href;
}

const initEventHandlers = () => {
    $buildMyOwnBtn = $('.build-own-btn');
    $buildMyOwnModalCloseBtn = $('.js-close-btn');
    $buildMyOwnConfirmationModal = $('#BuildMyOwnConfirmationModal');
    $addCartBtn = $('.cart-add-btn[data-config="new"]');
    $buildMyOwnContinueBtn = $('.build-my-own__continue-btn');
    $reviewProductEditBtn = $('.edit-btn.review-edit-btn');
    $prevBtn = $('.cart-btn-prev');
    $nextBtn = $('.cart-btn-next');
    let $body = $('body');
    $body.on('click', '.crossSellAddProduct', crossSellAddProduct);
    $body.on('click', '.crossSellAddPack', crossSellAddPack);
    loadSearchValues();
    // Unbind/clear event handlers
    $buildMyOwnModalCloseBtn.off();
    $buildMyOwnBtn.off();
    $addCartBtn.off();
    $nextBtn.off();
    $prevBtn.off();
    $buildMyOwnContinueBtn.off();
    $reviewProductEditBtn.off();
    $(tryonceCheckbox).off();
    // Bind event handlers
    $buildMyOwnModalCloseBtn.on('click', closeBuildMyOwnModal);
    $buildMyOwnBtn.on('click', initBuildMyOwnConfirmationModal);
    $addCartBtn.on('click', addToCart);
    $nextBtn.on('click', nextBtnHandler);
    $prevBtn.on('click', prevBtnHandler);
    $buildMyOwnContinueBtn.on('click', initializeBuildFlow);
    $reviewProductEditBtn.on('click', renderProductPage);
    if(extensiveProductData.DisplayTryOnce) {
        $(tryonceCheckbox).change(function (e) {
            $(tryonceCheckbox).prop('checked', this.checked);
            const currentPreference = getTryoncePreference();
            console.log(currentPreference);
        });
        if(isMobile()) {
            $('.pack-summary').css('padding-bottom', '10rem');
        }
    } else {
        if(isMobile()) {
            $('.pack-summary').css('padding-bottom', '7rem');
        }
    }
};

// -------- Add to Cart ----------

const FORMATTER = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function calculateTotalUpcharge() {
    let totalUpcharge = 0;
    let totalBV = 0;
    $.each($('.pack-config-builder__content .stepgroup-qty'), function (index, element) {
        let thisUpcharge = FORMATTER.format($(this).data('upcharge-amount'));
        let thisBV = FORMATTER.format($(this).data('upcharge-bv'));
        let qty = Number($(this).val());
        totalUpcharge += Number(thisUpcharge) * qty;
        if(qty > 0) totalBV += Number(thisBV) * qty;
    });

    return { totalUpcharge, totalBV };
}

function updatePackUpcharges({ totalUpcharge, totalBV }) {
    let updatedPrice = calculatedPackagePrice + totalUpcharge;
    let updatedBV = packBaseBV + Math.round(totalBV);
    console.log('Updated pack price: ', updatedPrice, ', updated BV: ', updatedBV);
    let displayPrice = updatedPrice % 1 === 0
        ? currencyFormatter
            .format(updatedPrice)
            .replace(
                marketSettings.Currency,
                marketSettings.CurrencySymbolAbbreviation.trim()
            )
        : fractionCurrencyFormatter
            .format(updatedPrice)
            .replace(
                marketSettings.Currency,
                marketSettings.CurrencySymbolAbbreviation.trim()
            );
    $('.packconfig-display-price').text(displayPrice);
    $('.total-pack-bv').text(updatedBV);
}

function addGtmTagToAddToCart() {
    let lastEvent = window.ga_props[window.ga_props.length - 1];
    console.log(lastEvent);
    if(!lastEvent) return;
    var memberId = lastEvent.MemberId;
    var memberType = lastEvent.MemberType;
    var currency = lastEvent.Currency;
    var cultureCode = lastEvent.CultureCode;
    var catalog = lastEvent.CatalogName;
    var category = lastEvent.Products[0].ProductFamilyName;
    var marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
    var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
    var preferredCultureCode = lastEvent.PreferredCultureCode;
    var hasAutoship = lastEvent.HasAutoship;
    var canEnroll = lastEvent.CanEnroll;
    var hasIsaDelivery = lastEvent.HasIsaDelivery;
    var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
    setDataForAllProducts(
        catalog,
        category,
        currency,
        memberType,
        memberId,
        cultureCode,
        marketingCloudUserId,
        isagenixMemberSubType,
        preferredCultureCode,
        hasAutoship,
        canEnroll,
        hasIsaDelivery,
        daysSinceEnrollment
    );

    console.log(lastEvent);
    var products = {
        name: lastEvent.Products[0].ProductName,
        id: lastEvent.Products[0].Sku,
        price: lastEvent.Products[0].Price, // need to get the selected price
        brand: lastEvent.Products[0].Brand,
        category: lastEvent.Products[0].ProductName,
        quantity: lastEvent.Products[0].Quantity
    };
    if(products && QUERY_ID) {
        products = { ...products, queryId: QUERY_ID };
    }
    if(products && INDEX_NAME) {
        products = { ...products, indexName: INDEX_NAME };
    }
    addGtmTagToCart(products);
}

function updateFooter(result) {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    if(currCartItems) {
        currCartItems.value = result.TotalItemCount;
    }
}

function setGAProperties(result) {
    if(result.GoogleAnalyticsProperties) {
        window.ga_props = window.ga_props || [];
        window.ga_props.push(result.GoogleAnalyticsProperties);
        addGtmTagToAddToCart();
    }
}

function showErrorMessage(text) {
    let $errorContainer = $('.product-tiles__cart-error');
    $errorContainer.children('.error-msg').text(text);
    $errorContainer.removeClass(IS_HIDDEN).addClass(IS_ACTIVE);
    $errorContainer.show();
}

function hideErrorMessage() {
    let $errorContainer = $('.product-tiles__cart-error');
    $errorContainer.children('.error-msg').text('');
    $errorContainer.removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
    $errorContainer.hide();
}

function getPackRequest(pack) {
    let request = {};
    let priceType = $("input[name='priceType']:checked").attr('id');
    let selectedPriceTier = pack.PackPrices.find((x) => x.Tier === priceType);
    let price = selectedPriceTier && selectedPriceTier.Price ? selectedPriceTier.Price : 0;
    if(!pack) return request;

    request.itemid = pack.Id;
    request.bundleConfigurationId = pack.BundleConfigurationId;
    request.catalog = 'Isagenix_Master';
    request.productPageRelativeUrl = window.location.pathname;
    request.quantity = $('.price__single-quantity-selector')
        .find('input[name="quantity"]')
        .val();
    request.choices = [];
    request.PriceType = priceType;
    request.Sku = pack.Sku;
    request.Price = price.toString();

    let tryOnce = false;
    if($(tryonceCheckbox).length > 0) {
        tryOnce = $(tryonceCheckbox).is(':checked');
    }
    request.TryOnce = tryOnce;

    if(selectedProducts) {
        //eslint-disable-line
        for (let groupId in selectedProducts) {
            for (let productId in selectedProducts[groupId]) {
                let groupElement = selectedProducts[groupId];
                let productCount = groupElement[productId];
                if(productCount > 0) {
                    request.choices.push({
                        groupid: groupId,
                        productid: productId,
                        value: productCount
                    });
                }
            }
        }
    }
    let includedInPackGroup = pack.PackGroups.find(
        (grp) => grp.GroupType === 'Included'
    );
    if(!!includedInPackGroup && !!includedInPackGroup.Products) {
        includedInPackGroup.Products.forEach(function (item, index) {
            if(item.Quantity) {
                request.choices.push({
                    groupid: includedInPackGroup.GroupID,
                    productid: item.ID,
                    value: item.Quantity
                });
            }
        });
    }
    return request;
}

function updateCrossSellCards(result) {
    let $modalSubheader = '#crossSellSubHeader';
    $($modalSubheader).html('');
    let $youMightAlsoEnjoy = $('#YouMightAlsoEnjoy').val();

    if(result.CrossSellProducts && result.CrossSellProducts.length) {
        crossSellData = result.CrossSellProducts;
        console.log(crossSellData);
        let $crossSellResult = {
            products: result.CrossSellProducts,
            isTaxInclusive: result.IsTaxInclusive,
            labels: {
                unavailable: $('#Unavailable').val(),
                buildMyPack: $('#BuildMyPack').val(),
                addToCart: $('#AddToCart').val(),
                taxInclusivePriceText: $('#hdnTaxInclusiveText').val()
            }
        };

        $($modalSubheader).html($youMightAlsoEnjoy);
        let $modalBlock = $('.cross-sell-modal');
        let $crossSellProducts = crossSellCards($crossSellResult);
        $modalBlock.empty().append($crossSellProducts);

        result.CrossSellProducts.forEach(function (product) {
            if(product && product.IsCheckStock) {
                checkCrossSellStock(product.Id);
            }
        });
    }
}

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find((msg) => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}

async function checkCrossSellStock(productId) {
    let $unavailable = $('#Unavailable').val();
    let idsToCheck = [productId];
    var response = await inventoryService.getUnavailableInventory(idsToCheck);
    if(response && response.length > 0) {
        $('#' + productId)
            .find('.buttonCrossSell')
            .addClass('card-button-disable')
            .attr('disabled', 'disabled')
            .text($unavailable);
        $('#' + productId)
            .find('.buttonCrossSell')
            .removeClass('crossSellAddProduct');
    }
}

function crossSellAddProduct() {
    let $itemAddedToCart = $('#ItemAddedToCart').val();
    let $crossSellCard = $(this).closest('.isa-modal__product');
    let $crossSellProductId = $(this).attr('id');
    let crossSellselectedProduct = (!crossSellData) ? null : crossSellData.find(item => item.Id === $crossSellProductId);
    if(!crossSellselectedProduct) return;

    $crossSellCard.prepend(`<div class="card-selected">
    <i class="fal fa-circle-check icon-circle-check-whiteBG mr-md"></i>
    <h4>${$itemAddedToCart}</h4></div>`);
    addCrossSellProductToCart(crossSellselectedProduct);
}

async function addToCart(elem) {
    let $searchParams = new URLSearchParams(window.location.search);
    let $iscrossSell = $searchParams.get('iscrosssell');
    let $isquickadd = $searchParams.get('isquickadd');
    let $isQuickAddStatus = Boolean(Number($isquickadd));
    $iscrossSell = Boolean(Number($iscrossSell));
    const isEdit = $('.cart-add-btn').data('isedit');
    hideErrorMessage();
    if(!isEdit) {
        showSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
        try {
            let request = getPackRequest(extensiveProductData.BundleConfiguration);
            console.log(request);
            request.FamilyId = familyId;
            request.IsCrossSell = $iscrossSell;
            request.IsQuickAdd = $isQuickAddStatus;
            request.quantity = $isquickadd;

            const result = await cartService.addPackToCart(addQueryIdToRequest(request));
            console.log(result);
            if(result.IsSuccessful) {
                hideSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
                setGAProperties(result);
                //eslint-disable-line
                cartService.updateQSForMergeCart();
                if(result.RedirectString) {
                    window.location = result.RedirectString;
                } else {
                    hideCartModalShoppingContext(request.PriceType);
                    let productData = extensiveProductData;
                    if(productData && productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                        updateTryOnceDisplayAfterAddToCart();
                    }
                    $('.cartModal .isa-modal__product-name').text(result.ProductName);
                    console.log($('.cartModal'));
                    let $productMeta = $('.cartModal .isa-modal__product-meta');
                    let $productImage = $('.isa-modal__product-image');
                    $productMeta.empty();

                    if(result.ProductImage) {
                        $productImage.attr('src', result.ProductImage);
                    }

                    $.each(result.Facets, function () {
                        if(this.Value) {
                            $productMeta.append(`<div class="row isa-modal__product-meta-item" >
                              <div class="col-lg-4 col-md-5 col-sm-5 col-5 isa-modal__product-meta-item-Left"><span>${this.Name}:</span></div>
                              <div class="col-lg-8 col-md-7 col-sm-7 col-7 isa-modal__product-meta-item-Right"><span style="font-weight: bold; word-wrap: break-word">${this.Value}</span></div>
                              </div>`);
                        }
                    });

                    let $qtyText = $('#hdnQuantityText').val();
                    let $quantity = Math.floor(result.Quantity);
                    $productMeta.append(`<div class="row isa-modal__product-meta-item" >
                      <div class="col-lg-4 col-md-5 col-sm-5 col-5 isa-modal__product-meta-item-Left"><span>${$qtyText}:</span></div>
                      <div class="col-lg-8 col-md-7 col-sm-7 col-7 isa-modal__product-meta-item-Right"><span style="font-weight: bold; word-wrap: break-word">${$quantity}</span></div>
                      </div>`);

                    if(result.TryOnce) {
                        $productMeta.append(
                            `<div class="tryonce row" style="text-align:left">
                              <div class="col-lg-12 col-md-12 col-sm-12"><span style="">${productData.Labels.NextOrderOnlyLabel}</span>
                              <button type="button" class="btn btn-tryonce" data-toggle="tooltip" data-placement="top" data-html="true" title="" data-original-title="${productData.Labels.TryOnceLabelTooltipMsg}">
                              <i class="fal fa-circle-info tooltip32 price__icon price__icon--exclamation"></i>
                              </button></div>`
                        );
                    }

                    $('.isa-modal__cart-total').text(result.SubtotalForDisplay);
                    let $subHeader = $('.isa-modal__cart .card-subheader');
                    if($subHeader.length) {
                        let subtitle = $subHeader.data('title');
                        subtitle = subtitle.replace('###', result.TotalItemCount);
                        $subHeader.empty().append(subtitle);
                    }
                    $('.header__cart-items').removeClass('d-none').text(result.TotalItemCount);
                    announceAddedToCart(result.ProductName, result.TotalItemCount);
                    updateCrossSellCards(result);
                    $('.cartModal').modal('show');

                    if($('.price__block').length > 1) {
                        if(request.PriceType === BPCRETAIL) {
                            $(`.price__block:not(.${BPCRETAIL})`).remove();
                        } else {
                            $(`.price__block:not(.${request.PriceType})`).remove();
                        }
                    }
                    if($('.pdp-pricing-optimized__card').length > 1) {
                        $('.pdp-pricing-optimized__card:not(.pdp-pricing-optimized__card--selected)').remove();
                    }
                    updateFooter(result);
                    // on add to cart no more pack data retrieve required.
                }
                packConfigBuilder.find('.back-btn').trigger('click');
            } else {
                addToCartFailed(result);
                hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
        }
    } else {
        showSpinner(UPDATE_TO_CART_LOADING_STARTED_MESSAGE);
        try {
            let request = getPackRequest(extensiveProductData.BundleConfiguration);
            request.CartlineId = $('.product').data('clid');
            const result = await cartService.editPackCartLine(request);
            if(result.IsSuccessful) {
                hideSpinner(UPDATE_TO_CART_LOADING_COMPLETED_MESSAGE);
                setGAProperties(result);
                window.location.href = $('.product').data('cartpageurl');
            } else {
                console.log(result);
                addToCartFailed(result);
                hideSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            hideSpinner(UPDATE_TO_CART_LOADING_ERROR_MESSAGE);
        }
    }
}

// -------- Initialize Pack-price -----------

function initPackagePrice() {
    let productData = extensiveProductData;

    let packData = productData.BundleConfiguration;
    familyId = productData.ProductFamily[0].ID;
    if(packData) {
        for (
            let packPriceCount = 0;
            packPriceCount < packData.PackPrices.length;
            packPriceCount++
        ) {
            if(selectedPriceType === packData.PackPrices[packPriceCount].Tier) {
                let { totalUpcharge, totalBV } = calculateTotalUpcharge();
                calculatedPackagePrice = packData.PackPrices[packPriceCount].Price;
                packBaseBV = packData.PackPrices[packPriceCount].BV || packData.PackBV;
                let calculatedPackagePricePlusUpcharge = calculatedPackagePrice + totalUpcharge;
                let calculatedPackageBVUpcharge = packBaseBV + Math.round(totalBV);
                $('.total-pack-bv').text(calculatedPackageBVUpcharge);
                console.log(
                    'Initialized pack price: ',
                    calculatedPackagePricePlusUpcharge,
                    ', updated BV: ',
                    calculatedPackageBVUpcharge
                );
                if(marketSettings.CurrencySymbolAbbreviation) {
                    if(calculatedPackagePricePlusUpcharge % 1 === 0) {
                        $(PACK_PRICE)
                            .filter(function () {
                                return $(this).parent().data('usertype') === selectedPriceType;
                            })
                            .html(
                                currencyFormatter
                                    .format(calculatedPackagePricePlusUpcharge)
                                    .replace(
                                        marketSettings.Currency,
                                        marketSettings.CurrencySymbolAbbreviation.trim()
                                    )
                            );
                    } else {
                        $(PACK_PRICE)
                            .filter(function () {
                                return $(this).parent().data('usertype') === selectedPriceType;
                            })
                            .html(
                                fractionCurrencyFormatter
                                    .format(calculatedPackagePricePlusUpcharge)
                                    .replace(
                                        marketSettings.Currency,
                                        marketSettings.CurrencySymbolAbbreviation.trim()
                                    )
                            );
                    }
                } else {
                    if(calculatedPackagePricePlusUpcharge % 1 === 0) {
                        $(PACK_PRICE)
                            .filter(function () {
                                return $(this).parent().data('usertype') === selectedPriceType;
                            })
                            .html(
                                currencyFormatter.format(calculatedPackagePricePlusUpcharge)
                            );
                    } else {
                        $(PACK_PRICE)
                            .filter(function () {
                                return $(this).parent().data('usertype') === selectedPriceType;
                            })
                            .html(
                                fractionCurrencyFormatter.format(
                                    calculatedPackagePricePlusUpcharge
                                )
                            );
                    }
                }
            }
        }
    }
}

function initCurrencyFormatter() {
    fractionCurrencyFormatter = getFractionCurrencyFormatter(marketSettings); // eslint-disable-line
    currencyFormatter = getCurrencyFormatter(marketSettings); //eslint-disable-line
}

function openPackConfigBuilder() {
    const params = new URLSearchParams(window.location.search);
    if(params && params.get('open') === '1') {
        $('.js-build-pack:visible').trigger('click');
    }
}

function isEditingPack() {
    const params = new URLSearchParams(window.location.search);
    return params.has('edit');
}

function getProductFromPackGroups(productId, packGroups) {
    let searchResult = [];
    packGroups.forEach(function (packGroup, pckGrpIdx) {
        let product = packGroup.Products.find(x => x.ID === productId);
        if(product) {
            searchResult.push({
                GroupId: packGroup.GroupID,
                Product: product,
                MaxQuantity: packGroup.MaxQuantity
            });
        }
    });
    return searchResult;
}

function getEditingPack() {
    let editingPack = JSON.parse(JSON.stringify(extensiveProductData.BundleConfiguration.DefaultPack));
    if(!extensiveProductData.EditProduct) return editingPack;
    if(!extensiveProductData.EditProduct.IsPack || !extensiveProductData.EditProduct.PackChoices) return editingPack;
    if(!Array.isArray(extensiveProductData.EditProduct.PackChoices)) return editingPack;

    editingPack.forEach(function (group, grpIdx) {
        // clear selected products in each group
        group.Products = [];
    });
    extensiveProductData.EditProduct.PackChoices.forEach(function (item) {
        let tempItem = JSON.parse(JSON.stringify(item));
        let result = getProductFromPackGroups(tempItem.ProductId, extensiveProductData.BundleConfiguration.PackGroups);
        if(result.length > 0) {
            result.forEach(function (productGroup, pgIdx) {
                let group = editingPack.find(x => x.GroupID === productGroup.GroupId);
                if(group && (group.Products.length < productGroup.MaxQuantity || group.IsIncludedTypeGroup)) {
                    let assignQty = tempItem.Quantity;
                    if(item.Quantity > productGroup.MaxQuantity) {
                        assignQty = productGroup.MaxQuantity;
                        tempItem.Quantity = tempItem.Quantity - productGroup.MaxQuantity;
                    }
                    group.Products.push({ ProductID: tempItem.ProductId, Quantity: assignQty });
                }
            });
        }
    });
    return editingPack;
}

function updatePDPWhenEditingPack() {
    $('.product').data('clid', extensiveProductData.EditProduct.CartlineId);
    $('.quantity-input').val(extensiveProductData.EditProduct.Quantity);
    let $addCartBtn = $('.cart-add-btn');
    let $cancelEditBtn = $('.cancel-edit');
    let $closebtn = $('.close');

    updateTryOnceDisplay();
    if(extensiveProductData.EditProduct.IsTryOnce) {
        $(tryonceCheckbox).prop('checked', true);
    }
    $addCartBtn.text(extensiveProductData.Labels.SaveButtonText);
    $cancelEditBtn.removeClass('d-none');
    $addCartBtn.data('isedit', true);
    $closebtn.data('isedit', true);
    if(!extensiveProductData.IsAssistedEnrollment) {
        $('.js-build-pack:visible').trigger('click');
    }
}

function showTryOnce() {
    if(isMobile()) {
        $('.tryonce.desktop').hide();
        $('.tryonce.mobile').show();
    } else {
        $('.tryonce.mobile').hide();
        $('.tryonce.desktop').show();
    }
}

function updateTryOnceDisplay() {
    if(extensiveProductData.DisplayTryOnce && !extensiveProductData.HideTryOnce) {
        showTryOnce();
    } else {
        $('.tryonce').hide();
    }
}

function updateTryOnceDisplayAfterAddToCart() {
    if(extensiveProductData.DisplayTryOnce && extensiveProductData.HideTryOnce) {
        showTryOnce();
    }
}

function enableDisableProduct(outOfStockProductIds) {
    if(!isManageAutoship()) {
        $.each(outOfStockProductIds, function () {
            const $input = $(`.stepgroup-qty.new-config-btn[data-productid=` + this + `]`);
            $input.prop('disabled', true);
            $input.siblings().prop('disabled', true);
            $input.parents('.product-tiles__flavour-card,.product-tiles__card.single-flavour').addClass('is--disabled');
        });
    } else {
        // when in manage autoship, enable all products
        const $input = $('.stepgroup-qty.new-config-btn');
        $input.prop('disabled', false);
        $input.siblings('.qty-addsub-plus-btn').prop('disabled', false);
        $input.parents('.product-tiles__flavour-card,.product-tiles__card.single-flavour').removeClass('is--disabled');
    }
}

function verifyProductsInDefaultPack() {
    extensiveProductData.BundleConfiguration.DefaultPack.forEach(function (group) {
        let tempProducts = group.Products.filter(p => p);
        if(tempProducts.length !== group.Products.length) {
            group.Products = tempProducts;
            console.log(`Warning, default pack with group Id ${group.GroupID} has a null product, it might be unavailable. Group: ${group}`);
        }
    });
}

function updatePackDataInventory() {
    if(!inventoryResponse || !Array.isArray(inventoryResponse)) return;
    inventoryResponse.forEach(function (productInventory) {
        extensiveProductData.BundleConfiguration.DefaultPack.forEach(function (group) {
            let defaultProduct = group.Products.find(p => p.ProductID === productInventory.ItemId);
            if(defaultProduct && defaultProduct.Quantity > productInventory.Count) {
                defaultProduct.IsCheckStock = true;
                defaultProduct.InventoryCount = productInventory.Count;
            }
        });
    });
    console.dir(extensiveProductData.BundleConfiguration.DefaultPack);
}

async function checkStock(packGroups) {
    if(!packGroups || packGroups.length < 1) return;

    let productList = packGroups.flatMap(i => i.Products);
    let idsToCheck = productList.filter(i => i.IsCheckStock).map(i => i.ID);
    // outOfStockProductIds = productList.filter(i => i.TempUnavailableMsg).map(i => i.ID);

    if(!idsToCheck || idsToCheck.length < 1) return;

    inventoryResponse = await inventoryService.getInventory(idsToCheck);
    if(inventoryResponse && inventoryResponse.length > 0) {
        outOfStockProductIds = outOfStockProductIds.concat(inventoryResponse.filter(i => i.Count < 1).map(i => i.ItemId));
    }
    console.log('outOfStockProductIds: ' + outOfStockProductIds);
}

async function togglePackConfigBuilderData(e) {
    if($(e.target).hasClass('addToCart')) { return; }
    let priceType = $("input[name='priceType']:checked").attr('id');
    let productData = $(PRODUCT).data('product-details');
    let isEdit = $('.cart-btn-add').data('isedit');
    let isEditingAssistedEnrollment = productData && productData.IsAssistedEnrollment && isEdit;
    if(!shouldTogglePackBuilderData || selectedPriceType === priceType || !priceType || isEditingAssistedEnrollment) { return; }
    e.preventDefault();
    showSpinner('Loading pack configuration details started');
    selectedPriceType = priceType;
    if(priceType === BPCRETAIL) {
        priceType = BPCRETAIL_SPACED;
    } else if(priceType.includes(BPC)) {
        priceType = priceType.replace(BPC, BPC_SPACED);
    }
    try {
        let data = {
            pdpID: $('#hidden-context-item').val(),
            userType: priceType.split('-')[0],
            userFlow: priceType.split('-')[1].replace(/([A-Z])/g, ' $1').trim()
        };

        // add show date param if existing (for price card/coming soon date testing on preview site)
        var showDate = new URLSearchParams(window.location.search).get('showdate');
        if(showDate) {
            data.showdate = showDate;
        }

        if(productData.IsAffiliateCustomer) {
            data.userFlow = '';
            data.userType = '';
        }
        let result = await productService.getProductDetailPageViewModel(data);
        if(result && result.BundleConfiguration) {
            initializePage({ data: result });
        } else {
            console.log(result);
        }
    } catch (ex) {
        console.error(ex);
    }
    hideSpinner('Loading pack configuration details completed');
}

function preInitPage(productData) {
    if(!productData.CustomerType && !productData.IsAuthenticatedUser && !productData.IsAssistedEnrollment) {
        shouldTogglePackBuilderData = true;
        selectedPriceType = 'Retail-Checkout';
        if(productData.IsBrandPartnerCustomer) {
            selectedPriceType = BPCRETAIL;
        }
        if(productData.IsAffiliateCustomer) {
            selectedPriceType = $("input[name='priceType']:checked").attr('id');
        }
    } else {
        selectedPriceType = $("input[name='priceType']:checked").attr('id');
    }
}

function postPageInitialization() {
    updatePackUpcharges(calculatePackPreselectedUpcharges());
    if(isEditingPack()) {
        updatePDPWhenEditingPack();
    } else {
        updateTryOnceDisplay();
        openPackConfigBuilder();
    }
}

async function buildForMeMaxQuantity(e) {
    let $product = $('.product');
    productData = $product.data('product-details');
    var paramProd = new URLSearchParams(window.location.search);
    var prodId = paramProd.get('pid');
    var prod = productData.Products.filter(function (product) {
        return product.ID === prodId;
    });

    if(prod.length > 0 && prod[0].PresaleData.IsValidPresaleItem && prod[0].PresaleData.CanPurchase) {
        var presalerequest = {
            'productSku': prod[0].Sku,
            'maxQuantity': prod[0].PresaleData.PresaleMax
        };

        const presaleResult = await cartService.presaleQuantityCheck(presalerequest);

        if(!presaleResult.CanAddToCart) {
            var presalemsg = `<div class="product-unavailable-message presaleQuantity-errormsg">
            <div class="product__unavailable">
                <p class="product-error product-error--unavailable" data-status="true">
                <span class="error-icon-unavailable"><i class="fal fa-exclamation-circle form__password-icon form__password-icon--error" aria-hidden="true"></i></span>
                <span class="psQuantity-errormsg">${presaleResult.Message}</span></p>
            </div>
        </div>`;

            $('.product-unavailable-message.presaleQuantity-errormsg').remove();
            $('.product__details .product__price .price__group').after(presalemsg);
            $('.product__details .product__price .price__group .js-build-pack').prop('disabled', true);
            $('.product__details .product__price .price__group .js-build-pack').removeClass('js-build-pack');
        } else {
            $('body').css('overflow', 'hidden');
            packConfigBuilder.show();
            $(e.currentTarget).hide();
            packConfigBuilder.find('.back-btn').focus();
        }
    } else {
        $('body').css('overflow', 'hidden');
        packConfigBuilder.show();
        $(e.currentTarget).hide();
        packConfigBuilder.find('.back-btn').focus();
    }
}

async function initializeData() {
    let $product = $('.product');
    extensiveProductData = $product.data('product-details');
    if(!extensiveProductData.BundleConfiguration) return;
    preInitPage(extensiveProductData);

    if(shouldTogglePackBuilderData) {
        $('.js-build-pack').on('click', togglePackConfigBuilderData);
    }
    verifyProductsInDefaultPack();
    await checkStock(extensiveProductData.BundleConfiguration.PackGroups);

    initializePage();

    $('.js-build-pack').on('click', (e) => {
        buildForMeMaxQuantity(e);
    });

    $('.continue-shopping-button, .cartModal .close').on('click', function (e) {
        if(packConfigBuilder.length > 0 && packConfigBuilder.is(':visible')) {
            $('body').css('overflow', 'visible');
            $('.js-build-pack').show();
            packConfigBuilder.hide();
        }
    });

    $('.back-btn').on('click', function (e) {
        $('body').css('overflow', 'visible');
        $('.js-build-pack').show();
        packConfigBuilder.hide();
    });
    if(isEditingPack()) {
        $('.pack-config-builder__header .right-section').hide();
    } else {
        $('.pack-config-builder__header .right-section').show();
    }

    postPageInitialization();
}

const initializePage = (options = {}) => {
    $header = $('.pack-config-builder__header');
    $footer = $('.pack-config-builder__footer');
    $content = $('.pack-config-builder__content-wrapper');

    // clear content container before initialization
    $content.empty();
    $footer.empty();

    // Note: importing JSON via js temporarily for development purposes because data attribute value is way too long
    if(options.data) extensiveProductData = options.data;
    updatePackDataInventory();
    console.log('extensive Product Data: ', extensiveProductData);

    productData = extensiveProductData.Products[0];
    familyId = extensiveProductData.ProductFamily[0].ID;
    const { Labels } = extensiveProductData;
    // Pack pricing lives on BundleConfiguration.PackPrices, not Products[0].PricesAndBV
    let priceTier = extensiveProductData.BundleConfiguration.PackPrices.find(x => x.Tier === selectedPriceType);

    footerData = {
        Product: { ...priceTier }, // selected Price tier
        DisplayBV: extensiveProductData.DisplayBV,
        TryOnce: {
            TryOnceLabel: extensiveProductData.Labels.TryOnceLabel,
            TryOnceLabelTooltipMsg:
                extensiveProductData.Labels.TryOnceLabelTooltipMsg,
            isHidden: !extensiveProductData.DisplayTryOnce
        },
        Labels,
        CartPageUrl: extensiveProductData.ProductDetailsViewModalModel.CartPageUrl,
        IsTaxInclusive: extensiveProductData.IsTaxInclusive,
        IsBundleLinkSession: extensiveProductData.IsBundleLinkSession
    };

    // Do not update defaultPack or packGroups
    if(isEditingPack() && !options.isBuildForMeReset) {
        selectedPack = getEditingPack();
    } else {
        selectedPack = extensiveProductData.BundleConfiguration.DefaultPack;
    }

    defaultPack = selectedPack;
    packGroups = extensiveProductData.BundleConfiguration.PackGroups;
    let mainImageUrl = {
        MainImage: extensiveProductData.BundleConfiguration.PackImage
    };

    // Set total pack price
    // Update total pack price variables depending on which "Tier" the user has selected.
    if(!priceTier) {
        let priceSelected = $("input[name='priceType']:checked").attr('id');
        priceTier = extensiveProductData.BundleConfiguration.PackPrices.find(x => x.Tier === priceSelected);
    }
    defaultTotalPackPrice = priceTier.Price;
    updatedTotalPackPrice = defaultTotalPackPrice;

    // Set default pack data
    sortedDefaultPackData = processDefaultPack(defaultPack, packGroups, outOfStockProductIds);

    initCurrencyFormatter();
    initPackagePrice();

    let headerHtml = headerComponent({ productData, Labels });
    let footerHtml = footerComponent(footerData);
    let mainImageHtml = mainImageComponent(mainImageUrl);
    if(isEditingPack()) {
        extensiveProductData.IsEditMode = true;
    } else {
        extensiveProductData.IsEditMode = false;
    }
    let reviewHtml = reviewComponent(extensiveProductData);
    let reviewPackSummary = packSummaryReview({
        packData: sortedDefaultPackData,
        Labels
    });

    // Append handlebar files to their respective containers
    if(isFirstLoad) {
        $header.append(headerHtml);
        isFirstLoad = false;
    }
    $footer.append(footerHtml);
    $content.append(mainImageHtml);
    $content.append(reviewHtml);

    $reviewPackSummaryContainer = $('#ReviewPackSummary');
    $reviewPackSummaryContainer.append(reviewPackSummary);

    packConfigBuilder.after(buildMyOwnConfirmationModalComponent({ IsBundleLinkSession: extensiveProductData.IsBundleLinkSession, Labels }));
    packConfigBuilder.after(buildMyOwnStartOverModalComponent({ Labels }));

    isBuildForMeFlow = true;
    selectedProducts = generateSelectedProductsFromDefaultPack(defaultPack); // assign default pack to selectedProducts on page load

    initEventHandlers();
    let $dataToggleTooltip = $('[data-toggle="tooltip"]');
    if($dataToggleTooltip.length) {
        $dataToggleTooltip.tooltip();
    }
    if(isBuildForMeFlow) {
        $prevBtn.hide();
    } else {
        $prevBtn.show();
    }
    $addCartBtn.prop('disabled', false);

    initCurrencyFormatter();
    initPackagePrice();

    $('body').css('visibility', 'visible');
    console.log('New pack config is visible.');
};

function addQueryIdToRequest(request) {
    if(
        request !== null &&
        typeof request === 'object' &&
        request.constructor === Object &&
        typeof QUERY_ID === 'string' &&
        QUERY_ID.trim() !== ''
    ) {
        return addGlobalQueryIdToRequest(request, QUERY_ID);
    }

    return request;
}

function getFocusableElements($selector) {
    var $context = $selector || packConfigBuilder;

    return $context
        .find('a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])')
        .filter(':visible');
}

function setUpFocusTrap() {
    packConfigBuilder.on('keydown', (e) => {
        const $focusable = getFocusableElements().not(':disabled');
        if(!$focusable.length) return;

        const first = $focusable.first()[0];
        const last = $focusable.last()[0];
        const active = document.activeElement;
        if(e.key === 'Home') {
            e.preventDefault();
            const $parent = active.closest('.product-tiles');
            const $leftParent = active.closest('.pack-summary');
            if($($parent).length) {
                const firstProductCard = getFocusableElements($($parent).find('.product-tiles__card').first());
                if(firstProductCard.length) {
                    firstProductCard.first().focus();
                }
            } else if($($leftParent).length) {
                const firstPackSummaryItem = $($leftParent).find('.pack-summary__item:not(.no-cursor)').first();
                if(firstPackSummaryItem.length) {
                    firstPackSummaryItem.trigger('click');
                    firstPackSummaryItem.focus();
                }
            }
            return;
        }
        if(e.key === 'End') {
            e.preventDefault();
            const $parent = active.closest('.product-tiles');
            const $leftParent = active.closest('.pack-summary');
            if($($parent).length) {
                const lastProductCard = getFocusableElements($($parent).find('.product-tiles__card').last());
                if(lastProductCard.length) {
                    lastProductCard.first().focus();
                }
            } else if($($leftParent).length) {
                const lastPackSummaryItem = $($leftParent).find('.pack-summary__item:not(.no-cursor)').last();
                if(lastPackSummaryItem.length) {
                    lastPackSummaryItem.trigger('click');
                    lastPackSummaryItem.focus();
                }
            }
            return;
        }
        if(e.key !== 'Tab') return;
        if(!packConfigBuilder.is(':visible')) return;

        const exceptionModals = [
            document.getElementById('BuildMyOwnStartOverModal'),
            document.getElementById('BuildMyOwnConfirmationModal')
        ].filter(Boolean);

        const isInException = exceptionModals.some(modal => modal.contains(active));
        const isInside = packConfigBuilder[0].contains(active);

        if(!isInside && !isInException) {
            e.preventDefault();
            first.focus();
            return;
        }

        if(isInside) {
            if(e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
                return;
            }

            if(!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    packConfigBuilder.on('keydown', '.product-tiles__flavour-card', function (e) {
        if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const $focused = $(document.activeElement);
        const $parent = $focused.closest('.product-tiles__card-container');
        if(!$parent.length) return;
        const $allCards = $parent.find('.product-tiles__flavour-card');
        const $currentCard = $focused.closest('.product-tiles__flavour-card');
        const currentIndex = $allCards.index($currentCard);
        if(currentIndex === -1) return;

        e.preventDefault();
        let newIndex = e.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
        if(newIndex >= $allCards.length) newIndex = 0;
        if(newIndex < 0) newIndex = $allCards.length - 1;
        const $finalCard = $allCards.eq(newIndex);
        if(!$finalCard.length) return;
        const quantityClasses = ['stepgroup-qty', 'qty-addsub-minus-btn', 'qty-addsub-plus-btn'];
        const matchedClass = quantityClasses.find(cls => $focused.hasClass(cls));
        if(matchedClass && !$finalCard.hasClass('is--disabled')) {
            const $matchingElement = $finalCard.find('.' + matchedClass).first();
            if($matchingElement.length) {
                $matchingElement.focus();
                return;
            }
        }

        const $fallback = getFocusableElements($finalCard).first();
        if($fallback.length) {
            $fallback.focus();
        }
    });
}

function loadSearchValues() {
    try {
        const params = new URLSearchParams(window.location.search);
        let queryId = null;
        for (const [key, value] of params.entries()) {
            if(key.toLowerCase() === 'qid') {
                queryId = value;
                break;
            }
        }

        if(queryId && queryId !== null) {
            QUERY_ID = queryId;
            INDEX_NAME = window?.algoliaData?.searchIndexName;
        }
    } catch (error) {
        console.error('Failed to load search cookie values:', error);
        QUERY_ID = null;
        INDEX_NAME = null;
    }
}

$(function () {
    packConfigBuilder = $('#PackConfigBuilder');
    if(packConfigBuilder.length > 0) {
        setUpFocusTrap();
        initializeData();
        packConfigBuilder.on('keydown', '.product-tiles__flavour-card', function (e) {
            const $focusable = getFocusableElements($(this)).not(':disabled');
            const len = $focusable.length;
            const currentIndex = $focusable.index($(document.activeElement));

            if(e.key === 'ArrowRight') {
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % len;
                $focusable.eq(nextIndex).focus();
            }

            if(e.key === 'ArrowLeft') {
                e.preventDefault();
                const prevIndex = (currentIndex - 1 + len) % len;
                $focusable.eq(prevIndex).focus();
            }
        });

        packConfigBuilder.on('keydown', '.pack-summary__item', function (e) {
            const dataGroupId = $(this).data('groupid');
            const $productCard = $(`#productCard_${dataGroupId}`);
            if($productCard.length) {
                if(e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).trigger('click');
                    $productCard.find('.product-name').focus();
                }
            }
            if(e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
                const $current = $(this).hasClass('.pack-summary__item') ? $(this) : $(this).closest('.pack-summary__item');
                const $items = $('.pack-summary .pack-summary__item');
                let index = $items.index($current);
                if(e.key === 'ArrowUp') {
                    index--;
                }
                if(e.key === 'ArrowDown') {
                    index++;
                }

                if(index < 0 || index >= $items.length) {
                    return;
                }
                const $nextItem = $items.eq(index);
                $nextItem.trigger('click');
                $nextItem.focus();
            }
        });

        packConfigBuilder.on('keydown', '.product-tiles', function (e) {
            const dataGroupId = $(this).data('groupid');
            const $productCard = $(`.pack-summary__item.editing-card[data-groupid='${dataGroupId}'`);
            if($productCard.length) {
                if(e.key === 'Escape') {
                    e.preventDefault();
                    $productCard.focus();
                }
            }
        });

        packConfigBuilder.on('keydown', function (e) {
            if(e.key !== 'Escape') return;
            if($(e.target).closest('.product-tiles').length > 0) {
                return;
            }
            packConfigBuilder.find('.back-btn').trigger('click');
            $('.js-build-pack:visible').first().focus();
        });
    }
});
